import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { UniDriverFactory } from '@wix/wix-ui-test-utils/uni-driver-factory';

export interface TimeTableUniDriver extends BaseUniDriver {
  getColumnCount(): Promise<number>;
  getTitleAt(columnIndex: number): Promise<string>;
  getSubtitleAt(columnIndex: number): Promise<string>;
  isColumnActiveAt(columnIndex: number): Promise<boolean>;
  isColumnDisabledAt(columnIndex: number): Promise<boolean>;
  isColumnDroppableAt(columnIndex: number): Promise<boolean>;
  getItemCountAt(columnIndex: number): Promise<number>;
  isItemDisabledAt(columnIndex: number, itemIndex: number): Promise<boolean>;
  isItemDraggableAt(columnIndex: number, itemIndex: number): Promise<boolean>;
  clickOnAddItemButtonAt(columnIndex: number): Promise<void>;
  addItemButtonExistsAt(columnIndex: number): Promise<boolean>;
  getActionsCount(columnIndex: number): Promise<number>;
  getActionLabelAt(columnIndex: number, actionIndex: number): Promise<void>;
  clickActionAt(columnIndex: number, actionIndex: number): Promise<void>;
  hoverColumn(columnIndex: number): Promise<void>;
}
declare const timeTableDriverFactory: UniDriverFactory<TimeTableUniDriver>;
